import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { Select } from '@creditornot/cb-select';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { languagesTranslationMap } from '../constants';

type Props = {
  availableLanguages: Language[];
  leftLanguage: Language | null;
  rightLanguage: Language | null;
  onLeftLanguageChange: (language: Language) => void;
  onRightLanguageChange: (language: Language) => void;
};

const Root = styled.div`
  display: flex;
  align-items: center;
  margin-block-start: 24px;
  background: ${cbSemanticCssVars.surfaceMain};
  border-radius: 2px;
`;

const StyledSelect = styled(Select)`
  flex: 1;
`;

const Separator = styled.div`
  width: 100px;
  font-size: 18px;
  overflow: hidden;
  text-align: center;
  color: ${cbSemanticCssVars.textPrimary};
`;

const LanguageComparisonSelector = ({
  availableLanguages,
  leftLanguage,
  rightLanguage,
  onLeftLanguageChange,
  onRightLanguageChange,
}: Props) => {
  const intl = useIntl();
  const leftOptions = availableLanguages
    .filter(l => l !== rightLanguage)
    .map(l => {
      return {
        label: intl.formatMessage({ id: languagesTranslationMap[l] }),
        value: l,
      };
    });
  const rightOptions = availableLanguages
    .filter(l => l !== leftLanguage)
    .map(l => {
      return {
        label: intl.formatMessage({ id: languagesTranslationMap[l] }),
        value: l,
      };
    });

  return (
    <Root>
      <StyledSelect
        value={leftLanguage || ''}
        options={leftOptions}
        clearable={false}
        placeholder={
          leftOptions.length === 0
            ? intl.formatMessage({ id: 'translation.noLanguageAvailable' })
            : intl.formatMessage({ id: 'translation.selectLanguage' })
        }
        onChange={(value: Language | null) => {
          if (value) {
            onLeftLanguageChange(value);
          }
        }}
      />
      <Separator>
        <FormattedMessage id="translation.vs" />
      </Separator>
      <StyledSelect
        value={rightLanguage || ''}
        options={rightOptions}
        clearable={false}
        placeholder={
          rightOptions.length === 0
            ? intl.formatMessage({ id: 'translation.noLanguageAvailable' })
            : intl.formatMessage({ id: 'translation.selectLanguage' })
        }
        onChange={(value: Language | null) => {
          if (value) {
            onRightLanguageChange(value);
          }
        }}
      />
    </Root>
  );
};

export default LanguageComparisonSelector;
